// PhoneCanvas масштабирует макет через CSS `zoom`. dnd-kit считает сдвиг в
// НЕотмасштабированных CSS-px и кладёт его в transform ВНУТРИ zoom-контейнера,
// где 1px = scale реальных пикселей. Без деления на scale элемент уезжает
// быстрее курсора.
import type { Modifier } from '@dnd-kit/core'

export const createScaleModifier =
  (scale: number): Modifier =>
  ({ transform }) => {
    if (!scale || scale <= 0) return transform
    return { ...transform, x: transform.x / scale, y: transform.y / scale }
  }
